import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=352abc93&"
import script from "./editForm?vue&type=script&lang=js&"
export * from "./editForm?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports